import React from 'react'
import styles from './Heading.module.css'

export const Heading = ({ children }) => <h6 className={styles.heading}>{children}</h6>